import { ChangeEvent, FC, useState } from 'react';
import { Field, Form, Label } from '../../Registration.styles';
import { Input } from '../../../../components';
import { RegistrationFormPage } from '../../templates';
import { useToastStore } from '../../../../stores';

const NewAccessory: FC = () => {
	const { setToast } = useToastStore();
	const [descricao, setDescricao] = useState<string>('');

	const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
		setDescricao(e.target.value);
	};

	const handleSubmit = () => {
		if (!descricao) {
			setToast({ message: 'Preencha todos os campos', variant: 'error' });
			return;
		}

	};

	return (
		<RegistrationFormPage title='Cadastrar Acessório' onSubmit={handleSubmit}>
			<Form>
				<Label>Descrição</Label>
				<Field>
					<Input
						variant='text'
						placeholder='Descrição'
						value={descricao}
						onChange={handleInputChange}
					/>
				</Field>
			</Form>
		</RegistrationFormPage>
	);
};

export default NewAccessory;
